import React from "react";

export enum CircleColorType {
  Blue = "#3B82F6",
  Green = "#4EA52F",
  Purple = "#8B5CF6",
  Orange = "#FFA700",
}

export interface CircleProps {
  color: CircleColorType;
  showWarning?: boolean;
  value: number;
  maxValue?: number;
}

export const Circle: React.FC<CircleProps> = ({
  color,
  showWarning,
  value,
  maxValue,
}) => {
  // If showWarning is true and maxValue is defined, show warning color when value >= maxValue
  const displayColor =
    showWarning && maxValue && value > maxValue
      ? CircleColorType.Orange
      : color;

  // Get appropriate background color based on the display color
  const getBgColor = (circleColor: CircleColorType) => {
    switch (circleColor) {
      case CircleColorType.Blue:
        return "bg-blue-100";
      case CircleColorType.Green:
        return "bg-green-100";
      case CircleColorType.Purple:
        return "bg-purple-100";
      case CircleColorType.Orange:
        return "bg-orange-100";
      default:
        return "bg-gray-100";
    }
  };

  return (
    <span
      className={`flex items-center justify-center w-4 h-4 rounded-full ${getBgColor(displayColor)} mr-1`}
      data-testid="circle-indicator"
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ backgroundColor: displayColor }}
        aria-label={displayColor === CircleColorType.Orange ? "warning" : "ok"}
        role="img"
      />
    </span>
  );
};
